var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgKycGreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10,
  fill: "#FFF",
  stroke: "#3FC788",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3FC788",
  d: "M13.866 7.366 9.75 11.483 8.134 9.866a1.249 1.249 0 1 0-1.768 1.768l2.5 2.5a1.247 1.247 0 0 0 1.768 0l5-5a1.249 1.249 0 1 0-1.768-1.768"
}))));
export { SvgKycGreen as ReactComponent };
export default __webpack_public_path__ + "assets/media/kyc-green.500707ac46cef69a49e206f69ba7a712.svg";